import type { MissionDashboard } from '@sentinel/shared';

/** What a team takes to the field from the PCA: its Sentinel Field phones and a LoRa node. */
export interface TeamReadiness {
  fields: number;
  node: boolean;
}

/** For every team of the mission: the Field phones that go with it (given to the team or to one
 *  of its members) and whether a LoRa node goes with it. The PCA solves the gaps before the team
 *  leaves (PCA e Segreteria, 3.4). */
export function teamReadiness(dashboard: MissionDashboard): Map<string, TeamReadiness> {
  const result = new Map<string, TeamReadiness>();
  for (const team of dashboard.teams) {
    const members = new Set(team.members.map((m) => m.id));
    const goesWith = (assignee: { type: string; id: string } | null) =>
      assignee !== null &&
      ((assignee.type === 'team' && assignee.id === team.id) ||
        (assignee.type === 'person' && members.has(assignee.id)));
    const mine = dashboard.devices.filter((d) => goesWith(d.assignedTo));
    result.set(team.id, {
      fields: mine.filter((d) => d.kind === 'field').length,
      node: mine.some((d) => d.kind === 'node' && d.assignedTo?.type === 'team'),
    });
  }
  return result;
}

/** Teams of the mission no LoRa node goes with. */
export function teamsWithoutNode(dashboard: MissionDashboard): number {
  let count = 0;
  for (const readiness of teamReadiness(dashboard).values()) if (!readiness.node) count += 1;
  return count;
}
